module.exports = __webpack_public_path__ + "img/ICaravan64_ua.e877dae6.webp";